import React, { useEffect, useRef } from 'react';

// Cloudflare Turnstile (Captcha). ENV-gegated: ohne
// REACT_APP_TURNSTILE_SITEKEY rendert die Komponente NICHTS (kein
// Script-Load, kein Verhaltenswechsel) — aktiviert sich, sobald der
// Sitekey gesetzt ist. Backend erzwingt die Prüfung nur, wenn dort
// TURNSTILE_SECRET gesetzt ist (s. _verify_turnstile).
const SITEKEY = process.env.REACT_APP_TURNSTILE_SITEKEY;
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let _scriptPromise = null;
function loadTurnstile() {
  if (typeof window === 'undefined') return Promise.reject();
  if (window.turnstile) return Promise.resolve();
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('turnstile script load failed'));
    document.head.appendChild(s);
  });
  return _scriptPromise;
}

const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!SITEKEY) return undefined;
    let cancelled = false;
    loadTurnstile()
      .then(() => {
        if (cancelled || !containerRef.current || !window.turnstile) return;
        widgetIdRef.current = window.turnstile.render(containerRef.current, {
          sitekey: SITEKEY,
          callback: (token) => onToken(token),
          'expired-callback': () => onToken(''),
          'error-callback': () => onToken(''),
        });
      })
      .catch(() => { /* Script-Load fehlgeschlagen -> kein Token */ });
    return () => {
      cancelled = true;
      if (widgetIdRef.current && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch { /* ignore */ }
      }
    };
  }, [onToken]);

  if (!SITEKEY) return null;
  return <div ref={containerRef} className="my-3 flex justify-center" />;
};

export default TurnstileWidget;
